import Pending from "@Images//pending.png";
import arrowleft from "@Images/NewUI/Vector.png";
import aadhaarr from "@Images/NewUI/aadhaarr.png";
import pancard from "@Images/NewUI/pancard.png";
import selfieicon from "@Images/NewUI/selfie.png";
import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  payme_bank_list,
  payme_manual_verification_description,
  payme_manual_verification_heading
} from "../../../../src/helper/modalConstant";
import completeIMG from "../../../Images/superTick.png";
import tickimg from "../../../Images/verifycheckblack.png";
import ModalBox from "../../../helper/modalBox";
import { withRouter } from "../../../hooks/withRouter";
import { HEADING_COMPLETEPROFILE } from "../Common/constant";


import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import {
  getDocumentStatus,
  postalcode,
  preSignedURL,
  submitManualKyc,
  upldateDocumentStatus,
  uploadDocsToS3,
} from "../../../Redux/Manual_Kyc_Details/action";
import InlineError from "../../../helper/InlineError";
import { validation } from "../../../helper/Validation";

import { Modal } from "react-bootstrap";
import sslencription from "../../../../src/Images/secure.png";
import ToastMsg from "../../../helper/ToastMsg";
import { Loader } from "../Common/Loader";
import Camera from "./Camera";
const toastOptions = {
  position: "top-center",
  autoClose: 2000,
  limit: 1,
  closeButton: false,
};


const options = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
};

const imageView = {
  width: 50,
  height: 50,
  
};

const CompleteYourProfile = (props) => {
  const navigate = useNavigate();
  let  token  =  props?.user?.User?.token||localStorage.getItem("gpay_token");
  const [modalState, setModalState] = useState(false);

  // console.log("testing", props?.userDetail?.customusermodel);
  const [state, setState] = useState({
    adhar_card_verified: "",
    pan_card_verified: "",
    basic_info_verified: "",
    adharFrontImageUrl: "",
    adharBackImageUrl: "",
    panImageUrl: "",
    selfieUrl: "",
    compressedImg: "",
    displayAdharFront: false,
    displayAdharBack: false,
    displayPanCard: false,
    presigned_urls: "",
    pan_card_number: "",
    gender: "",
    date_of_birth: "",
    first_name: "",
    permanent_address: "",
    permanent_pincode: "",
    permanent_house_no: "",
    permanent_street: "",
    permanent_landmark: "",
    city: "",
    state: "",
    panValid: true,
    stateValue: props.history.location.state,
  });
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [formInput, setFormInput] = useState(
    props?.userDetail?.customusermodel
  );
  const [selfiEerr, setSelfiEerr] = useState(""); 
  const [pancarderr, setPancarderr] = useState(""); 
  const [adharbackerr, setAdharbackerr] = useState(""); 
  const [adharfronterr, setAdharfronterr] = useState(""); 
  const [panerr, setPanerr] = useState("");
  const [pin, setPinCode] = useState("");
  const [pinInputDisabled, setpinInputDisabled] = useState(false);
  const [isPanSectionVisible, setIsPanSectionVisible] = useState(true)
  const [isAdharSectionVisible, setIsAdharSectionVisible] = useState(true)
  const [isSelfieSectionVisible, setIsSelfieSectionVisible] = useState(true)

  

  const handleInput = (name, value) => {
    setPanerr("");
    setErrors({ ...errors, [name]: "" });
    setFormInput({ ...formInput, [name]: value });
    
  };

  const notify = (err, name) => {
    setErrors({ ...errors, [name]: err });
  };
  // console.log(errors);
  useEffect(() => {
   
    let user_id = props.userDetail.id;
    props
      .getDocumentStatus(token)
      .then((res) => {
        // console.log(res?.data,  "majorresponse");
       
        res.data.map((item) => {
          setFormInput({
            ...formInput,
            pan_card_number: item.pan_card_number,
            permanent_house_no: item.permanent_house_no,
            permanent_street: item.permanent_street,
            pin: item.permanent_pincode,
            city: item.city,
            state: item.state,
            adhar_card_verified: item.adhar_card_verified,
            pan_card_verified: item.pan_card_verified,
            basic_info_verified: item.basic_info_verified,
            
          });
          // setState({...state,  adhar_card_verified: item.adhar_card_verified})
          setPinCode(item?.permanent_pincode)
          return setState({
            // pin: item.permanent_pincode,
            adhar_card_verified: item.adhar_card_verified,
            pan_card_verified: item.pan_card_verified,
            basic_info_verified: item.basic_info_verified,
          });
        });
        let data = {
          s3_path: [
            `adhar_card/${user_id}/back.jpg`,
            `adhar_card/${user_id}/front.jpg`,
            `pan_card/${user_id}/front.jpg`,
            `user_image/${user_id}/user_profile_photo.jpg`,
          ],
        };

        props
          .preSignedURL({ s3_path: data, token: token })
          .then((result) => {
            setState({ ...state, presigned_urls: result });
          })
          .catch((err) => {
            setLoader(false);
            if (err.response?.status === 401) {
             window.location.href = "/";
          localStorage.removeItem("gpay_token");
            }
            let error = err?.response?.data?.error;
            ToastMsg(error, "error");
            // console.log(err);
          });
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
         window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  }, []);
  const renderAdharWabcam = () => {
    setState({...state, adharFrontImageUrl: "", adharBackImageUrl: "",  displayAdharBack: false, displayAdharFront:false})
    // setState({...state, panImageUrl: ""});
    // if (state.panImageUrl === "") {
    //   setState({ displayPanCard: false });
    // }
  };

  const handleChangePermanentPincode = (e) => {
    const pincode = { pincode: e };
    if (e.length === 6) {
      props
        .postalcode({
          pincode,
          token,
        })
        .then((res) => {
          notify("", "pincodenotvalid");
          if (res.status === 200) {
            // console.log("pincodeapi", res);

            setFormInput({
              ...formInput,
              city: res?.data?.data?.city,
              state: res.data.data.state,
            });
            
          }
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
           window.location.href = "/";
          localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });
    }
  };

  const renderPanWabcam = () => {
    
    setState({...state, panImageUrl: "", displayPanCard: false})
  
  };

  const makeFormData = (result, imageValue) => {
    let formData = new FormData();
    Object.keys(result.fields).forEach((key) => {
      let value = result.fields[key];
      formData.append(key, value);
    });
    formData.append("file", imageValue);
    return formData;
  };

  const fileToDataUri = (file) => {
    const reader = new FileReader();
    // console.log("fule", file);

    return new Promise((resolve, reject) => {
      reader.onload = () => {
        const blob = new Blob([reader.result], { type: file.type });
        resolve(blob);
      };

      reader.onerror = () => {
        reject(reader.error);
      };

      reader.readAsArrayBuffer(file);
    });
  };

  const handleImage = (e, type) => {
    
    fileToDataUri(e.target.files[0]).then((blob) => {
      // console.log("blob", blob);
      let imageValue = URL.createObjectURL(blob);
      // console.log("fileData", imageValue);
      if (type === "adharFront") {
        setAdharfronterr("");
        setState({
          ...state,
          adharFrontImageUrl: imageValue,
          displayAdharFront: true,
        });
        uploadAadharFrontMedia(e.target.files[0]);
        return;
      }
      if (type === "adharBack") {
        setAdharbackerr("");
        setState({
          ...state,
          adharBackImageUrl: imageValue,
          displayAdharBack: true,
        });
        uploadAadharBackMedia(blob);
        return;
      }
      if (type === "panCard") {
        setPancarderr("")
        setState({ ...state, panImageUrl: imageValue, displayPanCard: true });
        uploadPanCardMedia(e.target.files[0]);
        return;
      }
    });
  };

  async function handleSelfieImage(b64Data) {
    // console.log(b64Data);
    const base64Response = await fetch(b64Data);
    const blob = await base64Response.blob();

    // let byteArray = new Uint8Array(b64Data);

    // let blob = new Blob([byteArray], { type: "image/png" });
    let imageValue = URL.createObjectURL(blob);
    setSelfiEerr("")
    setState({ ...state, selfieUrl: imageValue });
    uploadSelfieMedia(blob);
  }

  const handlePanVisible = () =>{
    // console.log(isPanSectionVisible, "1");
    
    setIsPanSectionVisible(!isPanSectionVisible)
    // console.log(isPanSectionVisible, "2");
  }
  const handleAdharVisible = () =>{
    setIsAdharSectionVisible(!isAdharSectionVisible)
  }
  const handleSelfieVisible = () =>{
    setIsSelfieSectionVisible(!isSelfieSectionVisible)
  }
  const uploadAadharFrontMedia = (blob) => {
    let user_id = props.userDetail.id;
    let data = {
      image_path: `adhar_card/${user_id}/front.jpg`,
    };
    let adhar_card_front_image = state.presigned_urls;

    let adhar_card_front_result =
      adhar_card_front_image.data[`adhar_card/${user_id}/front.jpg`];
    if (adhar_card_front_result) {
      let formData = makeFormData(adhar_card_front_result, blob);
      formData.append("key", data.image_path);
      props
        .uploadDocsToS3({
          url: adhar_card_front_result.url,
          formData,
        })
        .then((res) => {
          if (res.status === 204) {
            // console.log("adhar card front img uploaded");
          }
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
           window.location.href = "/";
          localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });
    }
  };

  const uploadAadharBackMedia = (blob) => {
    let user_id = props.userDetail.id;
    let data = {
      image_path: `adhar_card/${user_id}/back.jpg`,
    };
    let adhar_card_back_image = state.presigned_urls;
    let adhar_card_back_result =
      adhar_card_back_image.data[`adhar_card/${user_id}/back.jpg`];
    if (adhar_card_back_result) {
      let formData = makeFormData(adhar_card_back_result, blob);
      formData.append("key", data.image_path);
      props
        .uploadDocsToS3({
          url: adhar_card_back_result.url,
          formData,
        })
        .then((res) => {
          if (res.status === 204) {
            // console.log("adhar card back img uploaded");
          }
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
           window.location.href = "/";
          localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });
    }
  };

  const uploadPanCardMedia = (blob) => {
    let user_id = props.userDetail.id;
    let data = {
      image_path: `pan_card/${user_id}/front.jpg`,
    };
    let pan_card_front_img = state.presigned_urls;
    let pan_card_result =
      pan_card_front_img.data[`pan_card/${user_id}/front.jpg`];
    if (pan_card_result) {
      let formData = makeFormData(pan_card_result, blob);
      formData.append("key", data.image_path);
      props
        .uploadDocsToS3({
          url: pan_card_result.url,
          formData,
        })
        .then((res) => {
          if (res.status === 204) {
            // console.log("pan card img uploaded");
          }
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
           window.location.href = "/";
          localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });
    }
  };
  const addDays = (date, days) => {
    const copy = new Date(Number(date));
    copy.setDate(date.getDate() + days);
    return copy;
  };
  const uploadSelfieMedia = (blob) => {
    let user_id = props.userDetail.id;
    let data = {
      image_path: `user_image/${user_id}/user_profile_photo.jpg`,
    };
    let user_img = state.presigned_urls;
    let user_img_result =
      user_img.data[`user_image/${user_id}/user_profile_photo.jpg`];
    if (user_img_result) {
      let formData = makeFormData(user_img_result, blob);
      formData.append("key", data.image_path);
      props
        .uploadDocsToS3({
          url: user_img_result.url,
          formData,
        })
        .then((res) => {
          if (res.status === 204) {
            // console.log("user img uploaded");
          }
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
           window.location.href = "/";
          localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });
    }
  };
  const [selfie, setSelfie] = useState("");
  const handleCloseSefliePopup = () => {
    setShow(false);
  };

  const handleCapture = (image) => {
    handleSelfieImage(image);
    setSelfie(image);
    // console.log("image", image);
  };

  const submitKYCDetails = (e) => {
   
    e.preventDefault();
    if (!formInput?.first_name && !formInput?.last_name) {
      notify("Name can not be  blank", "first_name");
      return;
    }

    if (!formInput?.pan_card_number) {
      setPanerr("Pan card number can not be blank");
      return;
    }
    if (!formInput?.pan_card_number.toUpperCase().match(validation.pan)) {
      setPanerr("Please enter valid pan card number");
      return;
    }
    if (!formInput?.date_of_birth) {
      notify("Select date of birth", "date_of_birth");
      return;
    }

    if (!formInput?.gender) {
      notify("Select gender", "gender");

      return;
    }

    if (!formInput?.permanent_house_no) {
      notify("house number not blank", "permanent_house_no");
      return;
    }
    if (!formInput?.permanent_street) {
      notify("street not blank", "permanent_street");
      return;
    }
    if (!pin) {
      notify("pincode not blank", "permanent_pincode");
      return;
    }
    if (pin.length < 6) {
      notify("Please enter valid Pincode", "permanent_pincode");
      return;
    }
    if (!formInput?.city) {
      notify("City not blank", "city");
      return;
    }
    if (!formInput?.state) {
      notify("State not blank", "state");
      return;
    }


    if (formInput?.adhar_card_verified !== "VERIFIED" && formInput?.adhar_card_verified !== "PENDING_VERIFICATION") {
      if (!state.adharFrontImageUrl) {
        setAdharfronterr("Aadhaar front is mandatory", "adharFrontImageUrl");
        return;
      }
      if (!state.adharBackImageUrl) {
        setAdharbackerr("Aadhaar Back is mandatory", "adharFrontImageUrl");
        return;
      }
    }

  
if (formInput?.pan_card_verified !== "VERIFIED" && formInput?.pan_card_verified !== "PENDING_VERIFICATION") {
  if (!state.panImageUrl) {
    setPancarderr("Pan Card is mandatory", "panImageUrl");
    return;
  }
}
   
if (formInput?.pan_card_verified !== "VERIFIED" && formInput?.basic_info_verified !== "PENDING_VERIFICATION") {
  if (!state.selfieUrl && formInput?.basic_info_verified !== "VERIFIED") {
    setSelfiEerr("Live Selfie is mandatory", "selfieUrl");
    return;
  }
}

  

    setLoader(true);

    let count = 0;
    let user_id = props.userDetail.id;

    let jsonData = {
      pan_card_number: formInput.pan_card_number,
      gender: formInput.gender,
      dob: formInput?.date_of_birth,
      name_as_on_pan_card: formInput.first_name + " " + formInput?.last_name,
      permanent_address:
        formInput.permanent_house_no + " " + formInput.permanent_street,
      permanent_pincode: pin,
      permanent_house_no: formInput.permanent_house_no,
      permanent_street: formInput.permanent_street,
      city: formInput.city,
      state: formInput.state,
    };
    // setState({ isLoading: true });
    props
      .submitManualKyc({
        jsonData,
        token,
      })
      .then((res) => {
        if (res.status === 200) {
          // console.log("resssssssssssssssssssss", res);
          setState({ isLoading: false });
          // navigate(-1);

          // let dataArrayw = [
          //   {
          //     doc_type: "adhar_card",
          //     path: `adhar_card/${user_id}/front.jpg`,
          //   },
          //   {
          //     doc_type: "adhar_card",
          //     path: `adhar_card/${user_id}/back.jpg`,
          //   },
          //   {
          //     doc_type: "pan_card",
          //     path: `pan_card/${user_id}/front.jpg`,
          //   },
          //   {
          //     doc_type: "profile_pic_url",
          //     path: `user_image/${user_id}/user_profile_photo.jpg`,
          //   },
          // ];
          let dataArray = [
            
          ];
          if(formInput.adhar_card_verified !== "VERIFIED"){
            dataArray.push(
              {
                doc_type: "adhar_card",
                path: `adhar_card/${user_id}/front.jpg`,
              },
              {
                doc_type: "adhar_card",
                path: `adhar_card/${user_id}/back.jpg`,
              },
            )
          }
          if(formInput.pan_card_verified !== "VERIFIED"){
            dataArray.push(
              {
                doc_type: "pan_card",
                path: `pan_card/${user_id}/front.jpg`,
              },
            )
          }
          if(formInput.basic_info_verified !== "VERIFIED"){
            dataArray.push(
              {
                doc_type: "profile_pic_url",
                path: `user_image/${user_id}/user_profile_photo.jpg`,
              },
            )
          }
          dataArray.map((item) => {
            return props
              .upldateDocumentStatus({
                updateStatus: item,
                token: token,
              })
              .then((res) => {
                setLoader(false);
                if (res.status === 200) {
                  count = count + 1;
                }
                if (count === dataArray?.length) {
                  if (state.stateValue?.stateChange === "no") {
                    navigate("/kycverifyinprogress");
                  } else {
                    navigate("/kycverifyinprogress");
                  }
                  // props.history.push("/userProfile");
                }
              })
              .catch((err) => {
                setLoader(false);
                if (err.response?.status === 401) {
                 window.location.href = "/";
          localStorage.removeItem("gpay_token");
                }
                let error = err?.response?.data?.error;
                ToastMsg(error, "error");
                // console.log(err);
              });
          });
        }
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
         window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };

  // back = ()=> {
  //   if(stateValue?.stateChange=='no'){
  //     props.history.push('/userProfile')
  //   } else {
  //     props.history.push('/allUserDashboardScreen')
  //   }
  // }

  const [show, setShow] = useState(false);
  const handleWheel = (e) => {
    e.preventDefault();
  };

  // console.log(formInput.adhar_card_verified,"hellobuddyadharverified***");
  return (
    <div id="background" className="main_div">
      <div className=" ">
          {/* <Heading
            headingText={HEADING_COMPLETEPROFILE}
            history={props.history}
          /> */}
          <div className="customheading sticky-header  shadowline "> 
          <img style={{cursor:"pointer"}} className="customimgfixmanverif" src={arrowleft} onClick={() => {
          // window.location.href="/dashboard_s";
          navigate(-1)
          }} />
          
          
           <span style={{ paddingLeft:"27px", color:'#152745', fontWeight:'700', fontSize:'30px'}}>{HEADING_COMPLETEPROFILE}</span>
              {/* <img
              className="imageQuestionMark"
              onClick={() => {
                setModalState(true);
              }}
              src={questionImage}
            /> */}
          </div>

          
          <div className="wrapper-content e-sign container">
          <div className="wrapper-content container">
            <div className="overflow finalfix px-4 ticketHistoryBorder  py-4 w-100  text-black  rounder-10 newShadow">
              <div className="  d-flex flex-column  justify-content-between">
                <span className="benefits-h2 text-black">Benefits</span>
                <div className="pt-2">
                  <img width="16px" height="16px" src={tickimg} />
                  <span className="benefits-p">
                    Instant loan upto ₹ 5,00,000.
                  </span>
                </div>
                <div className="pt-2">
                  <img width="16px" height="16px" src={tickimg} />
                  <span className="benefits-p">100% paperless process.</span>
                </div>
                <div className="pt-2">
                  <img width="16px" height="16px" src={tickimg} />
                  <span className="benefits-p">
                    Easy and flexible repayment options.
                  </span>
                </div>
              </div>
            </div>
          </div>
            <div className=" px-4 pb-3 pt-1 w-100 mx-auto ">
              <div className="h-100 d-flex flex-column justify-content-between">
                <div className="pt-4 ">
                  <div className="form-div">
                    <div className="form-input-wrapper mt-20 mb-20">
                      <label>Name as on PAN card</label>
                      <input
                        type="text"
                        placeholder="Enter Name as on pan card"
                        name="first_name"
                        value={formInput?.first_name}
                        disabled={formInput?.pan_card_verified === "VERIFIED"}
                        onChange={(e) => {
                          if (
                            e.target.value === "" ||
                            e.target.value.match(validation?.nameValidation)
                          ) {
                            handleInput(
                              e.target.name,
                              e.target.value.slice(0, 40)
                            );
                          }
                        }}
                      />
                      <InlineError errorMessage={errors?.first_name} />
                    </div>
                    <div className="form-input-wrapper mt-20 mb-20">
                      <label>PAN number</label>
                      <input
                        type="text"
                        disabled={formInput?.pan_card_verified === "VERIFIED"}
                        placeholder="Enter Pan Card Number"
                        name="pan_card_number"
                        maxLength="10"
                        value={formInput?.pan_card_number}
                        onChange={(e) => {
                          if (e.target.value.length === 10) {
                            if (
                              e.target.value.toUpperCase().match(validation.pan)
                            ) {
                              setPanerr("");
                              setErrors({ ...errors, pan_card_number: "" });
                            } else {
                              setPanerr("Please Enter A Valid Pan Number");
                            }
                          }
                          if (
                            e.target.value
                              .toUpperCase()
                              .match(/^[A-Za-z0-9{" "}]+$/) ||
                            e.target.value === ""
                          ) {
                            handleInput(
                              e.target.name,
                              e.target.value.toUpperCase().slice(0, 10)
                            );
                          }
                        }}
                      />
                      <InlineError errorMessage={panerr} />
                    </div>
                    <div className="form-input-wrapper mt-20 mb-20">
                      <label>Date of Birth</label>
                      <DatePicker
                        dateFormat="mm/dd/yyyy"
                        name="date_of_birth"
                        disabled={formInput?.pan_card_verified === "VERIFIED"}
                        value={
                          formInput.date_of_birth
                            ? moment(formInput.date_of_birth).format(
                                "DD-MM-YYYY"
                              )
                            : ""
                        }
                        onChange={(e) => {
                          handleInput(
                            "date_of_birth",
                            moment(e).format("YYYY-MM-DD")
                          );
                        }}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="DD-MM-YYYY"
                        maxDate={addDays(new Date(), -6570)}
                      />
                      <InlineError errorMessage={errors?.date_of_birth} />
                    </div>
                    {/* <div className="form-input-wrapper mt-20 mb-20">
                      <label>Gender</label>

                      <select
                      className="selectbtn"
                        name="gender"
                        disabled={formInput?.pan_card_verified === "VERIFIED"}
                        onChange={(e) => {
                          handleInput(e.target.name, e.target.value);
                        }}
                        required
                        value={formInput?.gender || ""}
                      >
                        <option value="" disabled>
                          Select Gender
                        </option>

                        <option  value="male">Male</option>
                        <option value="female">Female</option>
                      </select>
                      <InlineError errorMessage={errors?.gender} />
                    </div> */}


<div className="form-input-wrapper mt-20 ">
      <label>Gender</label>
      <div className="gender-toggle-buttons">
        <label  className="gender-option">
          <input
            type="radio"
            name="gender"
            style={{width: "20px"}}
            value="male"
            disabled={formInput?.pan_card_verified === "VERIFIED"}
            onChange={(e) => handleInput(e.target.name, e.target.value)}
            checked={formInput?.gender === "male"}
          />
          <span className="gender-label">Male</span>
        </label>
        <label className="gender-option">
          <input
            type="radio"
            name="gender"
            style={{width: "20px"}}
            value="female"
            disabled={formInput?.pan_card_verified === "VERIFIED"}
            onChange={(e) => handleInput(e.target.name, e.target.value)}
            checked={formInput?.gender === "female"}
          />
          <span className="gender-label">Female</span>
        </label>
      </div>
      <InlineError errorMessage={errors?.gender} />
    </div>



                    <label className="addressAdhar">Address as on Aadhaar card</label>

                    <div className="form-input-wrapper radius10 benefitoutline">
                      
                      <div className="address-profile">
                        <div className="input-wrapper">
                          <div className="input-inner">
                            <span>
                              <strong className="font16600">House No/Flat No</strong>
                            </span>
                            <input
                              type="text"
                              className="font-size-12"
                              placeholder="House No"
                              disabled={formInput?.pan_card_verified === "VERIFIED"}
                              name="permanent_house_no"
                              value={formInput.permanent_house_no}
                              onChange={(e) => {
                                if (
                                  e.target.value.match(validation.text_number) ||
                                  e.target.value === ""
                                ) {
                                  handleInput(
                                    e.target.name,
                                    e.target.value.slice(0, 10)
                                  );
                                }
                              }}
                              maxLength="50"
                            />
                            <InlineError
                              errorMessage={errors?.permanent_house_no}
                            />
                          </div>
                          
                          <div className="input-inner">
                            <span>
                              <strong className="font16600">Street</strong>
                            </span>
                            <input
                              type="text"
                              className="font-size-16"
                              placeholder="Street"
                              disabled={formInput?.pan_card_verified === "VERIFIED"}
                              name="permanent_street"
                              value={formInput?.permanent_street}
                              onChange={(e) => {
                                if (
                                  e.target.value.match(validation.text_number) ||
                                  e.target.value === ""
                                )
                                  handleInput(
                                    e.target.name,
                                    e.target.value.slice(0, 50)
                                  );
                              }}
                              maxLength="50"
                            />
                            <InlineError
                              errorMessage={errors?.permanent_street}
                            />
                          </div>
                        </div>
                        <div className="input-wrapper">
                          <div className="input-inner">
                            <span>
                              <strong className="font16600">Pincode</strong>
                            </span>
                            <input
                              type="text"
                              className="font-size-16"
                              placeholder="Pincode"
                              name="permanent_pincode"
                              // disabled={formInput?.pan_card_verified === "VERIFIED"}
                              value={pin}
                              onChange={(e) => {
                                handleInput(
                                  e.target.name,
                                  e.target.value
                                    .replace(/[^0-9]/g, "")
                                    .slice(0,6)
                                );
                                setPinCode(
                                  e.target.value.replace(/[^0-9]/g, "").slice(0, 6) 
                                );
                                if (
                                  e.target.value.replace(/[^0-9]/g, "").length ===
                                  6
                                ) {
                                  setpinInputDisabled(true);
                                  setTimeout(() => {});
                                  handleChangePermanentPincode(
                                    e.target.value.slice(0, 6)
                                  );
                                }
                              }}
                              maxLength="6"
                              pattern="[0-9]{6}"
                            />
                            
                            <InlineError
                              errorMessage={
                                errors?.permanent_pincode ||
                                errors?.pincodenotvalid
                              }
                            />
                          </div>
                          <div className="input-inner">
                            <span>
                              <strong className="font16600">City</strong>
                            </span>
                            <input
                              type="text"
                              className="font-size-16"
                              placeholder="City"
                              name="city"
                              value={formInput?.city}
                              maxLength="50"
                              disabled
                            />
                            <InlineError errorMessage={errors?.city_err} />
                          </div>
                        </div>
                        <div className="input-wrapper">
                          <span>
                            <strong className="font16600">State</strong>
                          </span>
                          <input
                            type="text"
                            className="font-size-16"
                            placeholder="State"
                            name="state"
                            value={formInput?.state}
                            maxLength="50"
                            disabled
                          />
                          <InlineError errorMessage={errors?.state} />
                        </div>
                      </div>
                    </div>
                    <div className="upload_div flex mt-20">
  <div className="img_upload">
    <img width={51} height={51} src={aadhaarr} alt="aadhaarr" />
  </div>
  <div className="right_upl ">
    <p>
      <strong className="font20600">Upload Aadhaar card</strong>
    </p>
    <p className="ptagmanualverify mb-30">Kindly upload your Aadhar card for address verification</p>
    
    {formInput.adhar_card_verified === "VERIFIED" ? (
      <div className="verified_details">
        <p
          style={{
            color: "#02C650",
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          <img
            src={completeIMG}
            alt="paymeindia"
            width="18"
            style={{
              verticalAlign: "middle",
              marginRight: 5,
              marginTop: -5,
            }}
          />
          <span>Completed</span>
        </p>
      </div>
    ) : formInput.adhar_card_verified === "PENDING_VERIFICATION" ? (
      isAdharSectionVisible ? (
        <>
         <div className="dot ">
                      <img
                      src={Pending}
                      alt="paymeindia"
                      width="15"
                      height={15}
                      style={{
                        verticalAlign: "middle",
                      }}
                    />
                      </div> <span className="pendingClass yellow mr-10">Pending</span>
        <button className="NbfcBtntext3" onClick={handleAdharVisible}>Change</button>
        </>
      ) : (
        <div className="upload_here align-center flex">
          
          {state.adharFrontImageUrl ? (
            <img
              src={state.adharFrontImageUrl}
              className="paddingbottom40"
              alt="paymeindia"
              style={imageView}
            />
          ) : (
            <div className="file_div flex">
             <div>
             <span>+</span>
              <input
                type="file"
                accept="image/*, application/pdf"
                name="adharFront"
                onChange={(e) => handleImage(e, "adharFront")}
                className="input_file_c"
              />
              <br />
              <p>Front</p>
              </div>

              {/* <p onClick={handleAdharVisible} >Cancel</p> */}
            </div>
          )}
          <InlineError errorMessage={adharfronterr} />
          
          {state.adharBackImageUrl ? (
            <img
              src={state.adharBackImageUrl}
              alt="paymeindia"
              className="paddingbottom40"
              style={imageView}
            />
          ) : (
            <div className="file_div flex">
              <div>
              <span>+</span>
              <input
                type="file"
                name="adharBack"
                accept="image/*, application/pdf"
                onChange={(e) => handleImage(e, "adharBack")}
                className="input_file_c"
              />
              <br />
              <p>Back</p>
                </div>
              {/* <p onClick={handleAdharVisible} >Cancel x</p> */}
              {(!state.adharFrontImageUrl && !state.adharBackImageUrl) && (
            <div
              className=""
              onClick={handleAdharVisible} 
            >
              Cancel 
            </div>
          )}
            </div>
            
          )}
          <InlineError errorMessage={adharbackerr} />
          
          {(state.adharFrontImageUrl || state.adharBackImageUrl) && (
            <div
              className="removeImg paddingbottom40"
              onClick={renderAdharWabcam}
            >
              Cancel
            </div>
          )}
        </div>
      )
    ) : (
      <div className="upload_here align-center flex">
        
        {state.adharFrontImageUrl ? (
          <img
            src={state.adharFrontImageUrl}
            className="paddingbottom40"
            alt="paymeindia"
            style={imageView}
          />
        ) : (
          <div className="file_div">
            <span>+</span>
            <input
              type="file"
              accept="image/*, application/pdf"
              name="adharFront"
              onChange={(e) => handleImage(e, "adharFront")}
              className="input_file_c"
            />
            <br />
            <p>Front</p>
          </div>
        )}
        <InlineError errorMessage={adharfronterr} />
        
        {state.adharBackImageUrl ? (
          <img
            src={state.adharBackImageUrl}
            alt="paymeindia"
            className="paddingbottom40"
            style={imageView}
          />
        ) : (
          <div className="file_div">
            <span>+</span>
            <input
              type="file"
              name="adharBack"
              accept="image/* , application/pdf"
              onChange={(e) => handleImage(e, "adharBack")}
              className="input_file_c"
            />
            <br />
            <p>Back</p>
            
          </div>
        )}
        <InlineError errorMessage={adharbackerr} />
        
        {(state.adharFrontImageUrl || state.adharBackImageUrl) && (
          <div
            className="removeImg paddingbottom40"
            onClick={renderAdharWabcam}
          >
            Cancel
          </div>
        )}
      </div>
    )}
  </div>
</div>

                    <div className="upload_div flex">
  <div className="img_upload">
    <img src={pancard} alt="pancard" />
  </div>
  <div className="right_upl">
    <p>
      <strong className="font20600">Upload PAN card</strong>
    </p>
    <p className="ptagmanualverify mb-30">
      Kindly upload your PAN card for date of birth and other relevant verification.
    </p>
    {formInput.pan_card_verified === "VERIFIED" ? (
      <div className="verified_details">
        <p
          style={{
            color: "#02C650",
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          <img
            src={completeIMG}
            alt="paymeindia"
            width="18"
            style={{
              verticalAlign: "middle",
              marginRight: 5,
              marginTop: -5,
            }}
          />
          <span>Completed</span>
        </p>
      </div>
    ) : formInput.pan_card_verified === "PENDING_VERIFICATION" ? (
      isPanSectionVisible ? (
        <>
         <div className="dot ">
                      <img
                      src={Pending}
                      alt="paymeindia"
                      width="15"
                      height={15}
                      style={{
                        verticalAlign: "middle",
                      }}
                    />
                      </div> <span className="pendingClass yellow mr-10">Pending</span>
        
        <button className="NbfcBtntext3" onClick={handlePanVisible}>Change</button>
        </>
      ) : (
        <div className="upload_here flex align-center">
          <div>
            {state.panImageUrl ? (
              <div>
                <img
                  src={state.panImageUrl}
                  alt="paymeindia"
                  className="paddingbottom40"
                  style={imageView}
                />
                <div
                  className="removeImg adharimgtranslate"
                  onClick={renderPanWabcam}
                >
                  Cancel
                </div>
              </div>
            ) : (
              <div>
                <div className="webBtn" style={{ cursor: "pointer" }}>
                  <div className="file_div flex">
                    <div>
                    <span>+</span>
                    <input
                      type="file"
                      accept="image/*, application/pdf"
                      className="input_file_c"
                      onChange={(e) => {
                        handleImage(e, "panCard");
                      }}
                    />
                    <br />
                    <p>Upload</p>
                      </div>
                    <p onClick={handlePanVisible} >Cancel</p>
                  </div>
                  
                </div>
              </div>
            )}
            <InlineError errorMessage={pancarderr} />
          </div>
        </div>
      )
    ) : (
      <div className="upload_here flex align-center">
        <div>
          {state.panImageUrl ? (
            <div>
              <img
                src={state.panImageUrl}
                alt="paymeindia"
                className="paddingbottom40"
                style={imageView}
              />
              <div
                className="removeImg adharimgtranslate"
                onClick={renderPanWabcam}
              >
                Cancel
              </div>
            </div>
          ) : (
            <div>
              <div className="webBtn" style={{ cursor: "pointer" }}>
                <div className="file_div">
                  <span>+</span>
                  <input
                    type="file"
                    accept="image/*, application/pdf"
                    className="input_file_c"
                    onChange={(e) => {
                      handleImage(e, "panCard");
                    }}
                  />
                  <br />
                  <p>Upload</p>
                </div>
              </div>
            </div>
          )}
          <InlineError errorMessage={pancarderr} />
        </div>
      </div>
    )}
  </div>
</div>

<div className="upload_div flex">
  <div className="img_upload">
    <img
      src={selfieicon}
      alt="selfieicon"
      style={{ marginLeft: 0, marginRight: 0, height: 47 }}
    />
  </div>
  <div className="img_upload"></div>
  <div className="right_upl mb-100">
    <p>
      <strong className="font20600">Live Selfie</strong>
    </p>
    <p className="ptagmanualverify mb-30">
      Kindly upload your Selfie for your identification.
    </p>
    {formInput.basic_info_verified === "VERIFIED" ? (
      <div className="verified_details">
        <p
          style={{
            color: "#02C650",
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          <img
            src={completeIMG}
            alt="paymeindia"
            width="18"
            style={{
              verticalAlign: "middle",
              marginRight: 5,
              marginTop: -5,
            }}
          />
          <span>Completed</span>
        </p>
      </div>
    ) : formInput?.basic_info_verified === "PENDING_VERIFICATION" ? (
      isSelfieSectionVisible ? (
        <>
          <div className="dot">
            <img
              src={Pending}
              alt="paymeindia"
              width="15"
              height={15}
              style={{
                verticalAlign: "middle",
              }}
            />
          </div>
          <span className="pendingClass yellow mr-10">Pending</span>
          <button className="NbfcBtntext3" onClick={handleSelfieVisible}>
            Change
          </button>
        </>
      ) : (
        <div className="upload_here flex align-center">
          {selfie ? (

            
            <div>
              <img
                src={selfie}
                className="paddingbottom60"
                alt="paymeindia"
                style={imageView}
              />
            </div>
            
          ) : null}

          <div
            style={{ cursor: "pointer" }}
            className="webBtn"
            onClick={() => {
              setShow(true);
            }}
          >
            <div>
              <span style={{ display: selfie ? "none" : "" }}>+</span>
              <br />
              <p>{selfie ? "Retake" : "Capture"}</p>

              


            </div>
            
            <InlineError errorMessage={selfiEerr} />
          </div>
          <p onClick={handleSelfieVisible}  >Cancel</p>
        </div>
      )
    ) : <div className="upload_here flex align-center">
    {selfie ? (

      
      <div>
        <img
          src={selfie}
          className="paddingbottom60"
          alt="paymeindia"
          style={imageView}
        />
      </div>
      
    ) : null}

    <div
      style={{ cursor: "pointer" }}
      className="webBtn"
      onClick={() => {
        setShow(true);
      }}
    >
      <div>
        <span style={{ display: selfie ? "none" : "" }}>+</span>
        <br />
        <p>{selfie ? "Retake" : "Capture"}</p>

        


      </div>
      
      <InlineError errorMessage={selfiEerr} />
    </div>
    {/* <p onClick={handleSelfieVisible}  >Cancel</p> */}
  </div>}
  </div>
</div>

                  </div>
                </div>
              </div>
            </div>
           
          </div>
          
        </div>
      {loader ? <Loader /> : null}
      <div className=" toolbarRespo ">
        
        
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          show={show}
          centered
          style={{ width: "" }}
          className="video_modal"
        >
          <Modal.Body>
            <div className="modal_body">
              <Camera
                handleCapture={handleCapture}
                handleCloseSefliePopup={handleCloseSefliePopup}
              />
            </div>
          </Modal.Body>
        </Modal>
      </div>
       <br />
       <div style={{display:"flex", flexDirection:"column"}} className="button-wrapper text-center stickeybottomsign ">
          <button
            className="NbfcBtntext mb-20"
            onClick={submitKYCDetails}
          >
            Save
          </button>
          <br/>
          <img className="mb-20" width={87} height={23} src={sslencription} />
        </div>
         {modalState && (
        <ModalBox
          modalType={'description'}
         description={payme_manual_verification_description}
          heading={payme_manual_verification_heading}
          List={payme_bank_list}
          open={true}
          onChange={(props) => {
            setModalState(props);
          }}
          imagesVisible={true}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    userDetail: state.userDetail.user_detail,
  };
};
export default withRouter(connect(mapStateToProps, {
  getDocumentStatus,
  preSignedURL,
  uploadDocsToS3,
  upldateDocumentStatus,
  submitManualKyc,
  postalcode,
})(CompleteYourProfile));
